export default [
  {
    title: 'Product code',
    type: 'text',
    data: '',
    required: true,
    initialValue: '',
    note_text: '',
    additional: '',
    dataIndex: 'product_code',
    order: 1,
  }, {
    title: 'Sku',
    type: 'text',
    data: '',
    required: true,
    initialValue: '',
    note_text: '',
    additional: '',
    dataIndex: 'sku',
    order: 2,
  }, {
    title: 'Description',
    type: 'text',
    data: '',
    initialValue: '',
    note_text: '',
    additional: '',
    dataIndex: 'description',
  },
]